import type { SVGProps } from 'react';

export const DownloadImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>{'download-image'}</title>
    <g
      fill="none"
      fillRule="evenodd"
      id="icons/download-image"
      stroke="none"
      strokeWidth="1"
    >
      <rect height="32" id="Rectangle" width="32" x="0" y="0"></rect>
      <g id="download-image" stroke={props.fill} strokeWidth="1.5">
        <circle cx="22" cy="10" id="Oval" r="4.25"></circle>
        <rect
          height="30.5"
          id="Rectangle"
          rx="5"
          width="30.5"
          x="0.75"
          y="0.75"
        ></rect>
        <polyline
          id="Path-3"
          points="1.03262329 23.112 9.4854 14.552 19.8632355 23.304 25.5015411 18.928 31.2045593 23.304"
        ></polyline>
      </g>
    </g>
  </svg>
);
